<template>
  <div>
    <v-card class="elevation-0 mb-3">
      <v-toolbar class="elevation-0">
        <v-toolbar-title class="font-weight-light primary--text">Dane osobowe</v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <w-schema :model="$schema.profile.firstName">
          <v-text-field prepend-icon="person" name="profile.firstName" label="Imię"></v-text-field>
        </w-schema>

        <w-schema :model="$schema.profile.lastName">
          <v-text-field prepend-icon="person" name="profile.lastName" label="Nazwisko"></v-text-field>
        </w-schema>

        <w-schema :model="$schema.profile.pesel">
          <v-text-field prepend-icon="person" name="profile.pesel" label="Numer PESEL"></v-text-field>
        </w-schema>

        <w-schema :model="$schema.profile.phoneNumber">
          <v-text-field prepend-icon="person" name="profile.phoneNumber" label="Numer telefonu"></v-text-field>
        </w-schema>
      </v-card-text>
    </v-card>

    <v-card class="elevation-0 mb-3">
      <v-toolbar class="elevation-0">
        <v-toolbar-title class="font-weight-light primary--text">Adres</v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <teryt-form :schema="$schema.profile"></teryt-form>

        <div v-if="$schema.profile.simc.$value">
          <v-layout layout row wrap>
            <v-flex xs12 md4>
              <w-schema :model="$schema.profile.homeNumber">
                <v-text-field name="homeNumber" label="Numer budynku *"></v-text-field>
              </w-schema>
            </v-flex>
            <v-flex xs12 md4>
              <w-schema :model="$schema.profile.localNumber">
                <v-text-field name="localNumber" label="Numer lokalu"></v-text-field>
              </w-schema>
            </v-flex>
            <v-flex xs12 md4>
              <w-schema :model="$schema.profile.postalCode">
                <v-text-field name="postalCode" label="Kod pocztowy *"></v-text-field>
              </w-schema>
            </v-flex>
          </v-layout>
        </div>
      </v-card-text>

      <v-card class="elevation-0 mb-3">
        <v-toolbar class="elevation-0">
          <v-toolbar-title class="font-weight-light primary--text">Awatar</v-toolbar-title>
        </v-toolbar>

        <v-card-text>
          <single-image :schema="$schema.profile.mainImage"></single-image>
        </v-card-text>
      </v-card>
    </v-card>
  </div>
</template>

<script>
import { WSchema } from '@witkac/vuetify-components';

import TerytForm from '@/components/forms/TERYTForm';
import SingleImage from '@/components/forms/SingleImage';

// @vuese
// Formularz danych klienta
export default {
  components: { WSchema, SingleImage, TerytForm },
  props: {
    // schema profilu
    $schema: { type: Object, required: true }
  }
};
</script>
